import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {createHead} from "@vueuse/head";
import './i18n'
import './assets/ui-refresh.css'
import './assets/marketing-pages.css'
import './assets/steel-models.css'
const head = createHead()

createApp(App).use(store).use(router).use(head).mount('#app')
